import { ResourceDetailTab } from '@ciandtspike.io/plugin-ciandtspike-common';
import { CloudRunTab } from './components/CloudRunTab';

export const cloudRunDetailTab: ResourceDetailTab = {
  id: 'cloud-run',
  labelKey: 'Cloud Run',
  order: 10,
  appliesTo: detail => detail.specType === 'cloudrunapp',
  Component: CloudRunTab,
};
